import axios from 'axios';

var u_host = window.location.hostname; //正常使用
//var u_host = 'kefeiwang.com'; //在公司调试使用

// 创建一个axios实例
const service = axios.create({
  // 这里可以设置基础url，如果接口有统一的前缀
  baseURL: 'https://'+u_host+'/api/',
  // 设置超时时间
  timeout: 300000
});

var token = "kefeiwang";
// 请求拦截器
service.interceptors.request.use(
  config => {
    // 在发送请求之前做些什么，例如添加token
    config.headers['Authorization'] = `Bearer ${token}`;
    config.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
    return config;
  },
  error => {
    // 对请求错误做些什么
    console.error(error);
    return Promise.reject(error);
  }
);

// 响应拦截器
service.interceptors.response.use(
  response => {
    // 对响应数据做点什么
    return response.data;
  },
  error => {
    // 对响应错误做点什么
    alert("数据请求超时，请检查网络连接情况");
    console.error(error);
    return Promise.reject(error);
  }
);

// 封装get请求
export function get(url, params = {}) {
  return service.get(url, { params });
}

// 封装post请求
export function post(url, data = {}) {
  return service.post(url, data);
}


// WEBPACK FOOTER //
// ./src/api/apiService.js